<template>
	<div class="card-main"
		:style="{ width: cardWidth, height: cardHeight,'min-width':minWidth,'min-height':minHeight,'max-width':maxWidth,'max-height':maxHeight }">
		<div class="card-top">
			<!-- 修改1：支持自定义标题插槽，如果提供了就使用，否则显示默认标题 -->
			<slot name="card-title" v-if="$slots['card-title'] || $scopedSlots['card-title']">
				<!-- 默认显示 -->
				<div class="card-titlecard-title">{{ title }}</div>
			</slot>
			<div v-else class="card-title">{{ title }}</div>
			
			<div v-if="showCardMore" class="card-more" :style="{ justifyContent: toolJustifyontent, display: 'flex', alignItems: 'center', gap: '8px'}">
				<slot name="card-tool"></slot>
				<el-dropdown v-if="showExport || showColumnEdit" trigger="click" @command="handleMoreCommand" size="small">
					<i class="el-icon-more" style="cursor:pointer;padding:7px 0;"></i>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-if="showExport" command="export">导出Excel</el-dropdown-item>
						<el-dropdown-item v-if="showColumnEdit" command="edit-column">编辑列</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>


		<div class="card-box1" v-if="hasBox1Content">
		<slot name="card-box1"></slot>
		</div>		

		<div class="card-box2" v-if="hasBox2Content">
		<slot name="card-box2"></slot>
		</div>	

		<!-- 新增：中间行 - 筛选框区域（默认不显示） -->
		<div class="card-filter" v-if="showFilter && hasFilterContent">
			<slot name="card-filter">
				<!-- 默认筛选框插槽，可被父组件覆盖 -->
				<div class="default-filter">
					<!-- 这里可以放置默认的筛选组件 -->
					<!-- 例如：<el-input placeholder="请输入筛选条件" /> -->
				</div>
			</slot>
		</div>

		<div class="card-box">
			<slot name="card-box"></slot>
			<!--<card-table></card-table>-->
		</div>
	</div>
</template>

<script>
	export default {
		name: 'card-M',
		props: {
			title: {
				type: String,
				required: false,
				default: ''
			},
			cardWidth: {
				type: String,
				required: false,
				default: '47%'
			},
			cardHeight: {
				type: String,
				required: false,
				default: '45vh'
			},
			// minWidth: {
			// 	type: String,
			// 	required: false,
			// 	default: '440px'
			// },
			minHeight: {
				type: String,
				required: false,
				default: '325px'
			},
			maxWidth: {
				type: String,
				required: false,
				default: ''
			},
			toolWidth: {
				type: String,
				required: false,
				default: ''
			},
			toolJustifyontent: {
				type: String,
				required: false,
				default: 'space-around'
			},
			maxHeight: {
				type: String,
				required: false,
				// 这个是控制所有表格的最大高度，表格最大高度
				// default: '450px'
			},
			showSearch: {
				type: Boolean,
				required: false,
				default:false
			},
	
			placeholder: {
				type: String,
				required: false,
			},
			// 修改：新增 showFilter 属性，控制是否显示筛选区域
			showFilter: {
				type: Boolean,
				required: false,
				default: false  // 默认不显示筛选区域
			},
			// 新增：控制是否显示导出功能
			showExport: {
				type: Boolean,
				required: false,
				default: false
			},
			exportFileName: {
				type: String,
				required: false,
				default: '导出数据'
			},
			// 新增：控制是否显示编辑列功能
			showColumnEdit: {
				type: Boolean,
				required: false,
				default: false
			},
		},
		data() {
			return {
				default_placeholder: this.placeholder ? this.placeholder : "请输入内容",
			}},
		computed: {
			// 卡片的 card-more 区域是否显示（有工具插槽内容或有下拉菜单项时显示）
			showCardMore() {
				return !!this.$slots['card-tool'] || !!this.$scopedSlots['card-tool'] || this.showExport || this.showColumnEdit;
			},
			// 计算是否有筛选内容：如果插槽有内容，才显示筛选区域
			hasFilterContent() {
				// 检查 card-filter 插槽是否有内容
				return !!this.$slots['card-filter'] || 
					   !!this.$scopedSlots['card-filter'] ||
					   // 如果父组件没有提供插槽内容，但 showFilter 为 true 且我们希望显示默认内容
					   (this.showFilter && this.hasDefaultFilter());
			},

			// 【新增】计算是否有 card-box1 插槽内容
			hasBox1Content() {
				return !!this.$slots['card-box1'] || !!this.$scopedSlots['card-box1'];
			},			
			// 【新增】计算是否有 card-box1 插槽内容
			hasBox2Content() {
				return !!this.$slots['card-box2'] || !!this.$scopedSlots['card-box2'];
			}
		},

		methods: {
			search(data){
				this.$emit("search",data)
			},
			handleMoreCommand(command) {
				if (command === 'export') {
					this.$emit('export');
				} else if (command === 'edit-column') {
					this.$emit('edit-column');
				}
			}
		}
	};
</script>

<style scoped lang="scss">
/* ✅ 卡片边框：四边 1px 描边 + 浅阴影（和 contractinfo.vue 同一套）
   想改颜色 / 圆角 / 阴影只动下面这三个变量 */
$card-border: 1px solid #e6ebf5;
$card-radius: 10px;
$card-shadow: 2px 2px 6px rgba(0, 0, 0, .12);

	.card-main {
		/* 卡片 */
		position: relative;
		background: rgb(255, 255, 255);
		box-sizing: border-box;
		// margin-bottom: 20px;
		// margin-right: 20px;
		margin: 0;  /* 去掉自带的 margin-right: 20px，避免和 width:100% 一起横向溢出 */
		padding: 10px;
		// padding-top: 15px;
		// padding-bottom: 15px;
		// padding-right: 15px;
		// padding-left: 5px;
		// ✅ 四边 1px 描边 + 外阴影
		//    之前用 ::after 覆盖层 + 左上线 / 右下阴影那套，问题是：
		//      · 描边只有左 / 上两边的线，右 / 下靠阴影凑，视觉不对称；
		//      · 外投影画在元素自己的背景那一层，被 card-box 的 overflow:hidden 一裁就剩 5px；
		//      · 看着像"右边 / 下边没边"。
		//    改成四边实线 + 阴影：
		//      · 描边是元素 box 自己的一部分，内容怎么撑也撑不到 box 外；
		//      · 阴影只画在 box 外（外投影），不会被内部内容盖；
		//      · 不依赖 overflow 裁剪，手机端也能完整显示。
		//    —— 整套路子和 contractinfo.vue 那段一样，那边手机端能显示就是靠这个。
		border: $card-border;
		box-shadow: $card-shadow;
		border-radius: $card-radius;
		display: flex;
		flex-direction: column;
	}

	.card-top {
		display: flex;
		align-items: center;
		width: 100%;
		justify-content: space-between;
		margin-bottom: 0px;
		// background: rgb(255, 255, 0);

		.card-title {
			position: relative;
			color: rgb(128, 128, 128);
			font-family: Microsoft YaHei;
			font-size: 20px;
			font-weight: 700;
			line-height: 22px;
			letter-spacing: 1px;
			text-align: left;
			min-width: 30%;

		}

		.card-tool {
			display: flex;
			justify-content: space-around;
			// margin-right: 20px;
			font-size: 14px;
		}
	}

	/* 新增：筛选区域样式 */
	.card-filter {
		margin: 0px 0;
		padding: 0 0;
		// border-top: 1px solid #e0e0e0;
		// border-bottom: 1px solid #e0e0e0;
		// background: rgb(200, 255, 200); /* 测试背景色，可移除 */
		
		.default-filter {
			display: flex;
			gap: 10px;
			align-items: center;
		}
	}
	
	.card-box1 {
		height: 110px;
		
		// min-height: 60vh;
		padding: 5px 5px 5px 5px;
		position: relative;
		// display: flex;
	}

	.card-box2 {
		max-height: 430px;
		position: relative;
		// display: flex;
  		padding: 5px 0;

	}
	.card-box {
		height: 100%;
		
		// min-height: 60vh;
		padding: 5px 5px 5px 5px;
		position: relative;
		// display: flex;
		// ⚠️ 这里不能加 overflow:hidden —— 会把 ::after 的外投影（阴影）也一起裁掉，
		//    只剩 5px 在 card-box 的内边距里勉强可见，看着就是"右边 / 下边没边"。
		//    边框 / 阴影现在都画在 ::after 覆盖层上（z-index:3），
		//    内容怎么撑也盖不掉，不需要再靠 overflow 来保护。
	}

@media screen and (max-width: 768px) {
  .card-main {
	margin-bottom: 0 !important;
	margin-right: 0 !important;
    .card-box2 {
      flex-direction: column;
      height: auto;
      gap: 16px;
    //   height: 530px;
    }
  }

  .card-top {
    margin-bottom: 0px;
  }

  .card-top .card-title {
    font-size: 14px !important;
    line-height: 18px !important;
  }

  .card-more {
    gap: 2px !important;
    font-size: 11px !important;
  }

  .card-more i {
    font-size: 14px !important;
  }

  .card-box {
    padding: 2px !important;
  }
}

</style>